/* unplugin-vue-components disabled */import { render } from "./YImageMagnifier.vue?vue&type=template&id=70b77c72"
import script from "./YImageMagnifier.vue?vue&type=script&lang=js"
export * from "./YImageMagnifier.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./YImageMagnifier.vue?vue&type=style&index=0&id=70b77c72&lang=postcss&module=css"
cssModules["css"] = style0

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.3.4_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__